module.exports = __webpack_public_path__ + "static/img/surface6.4829455.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/surface6.png
// module id = orGC
// module chunks = 2